
import request from '@/utils/request.js'

export function getCodeUrl(data) {
  return request({
    url: '/wechatAction/getCodeUrl',
    method: 'post',
    data
  })
}


export function getUserAndToken(parameter) {
  return request({
    url: '/wechatAction/getUserAndToken',
    method: 'post',
    params: parameter
  })
}


export function getBanner(parameter) {
  return request({
    url: '/student/home/getBanner',
    method: 'post',
    params: parameter
  })
}

export function courseList(parameter) {
  return request({
    url: '/student/home/courseList',
    method: 'post',
    params: parameter
  })
}

export function courseDetail(parameter) {
  return request({
    url: '/student/home/query',
    method: 'post',
    params: parameter
  })
}
